import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { EventPageProps } from "./types";

export class EventCalendarDefinitions extends CmsReactComponent<EventPageProps> {
    static defaultProps = {};

    static schemaName = "event-calendar";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "rules",
        text: "Etkinlik Kuralları",
        mapping: {
            type: PropertyMappingType.ArrayData,
            keys: [
                {
                    name: "expanded",
                    mapping: {
                        type: PropertyMappingType.Boolean
                    },
                    text: "Aktif Mi?"
                },
                {
                    name: "title",
                    mapping: {
                        type: PropertyMappingType.String
                    },
                    text: "Başlık"
                },
                {
                    name: "iconBefore",
                    mapping: {
                        type: PropertyMappingType.Icon
                    },
                    text: "İkon (Önce)"
                },
                {
                    name: "iconAfter",
                    mapping: {
                        type: PropertyMappingType.Icon
                    },
                    text: "İkon (Sonra)"
                },
                {
                    name: "content",
                    text: "İçerik Açıklaması",
                    mapping: {
                        type: PropertyMappingType.Html
                    }
                },
            ]
        }
    }, {
        name: "artFestivalEventType",
        text: "Çocuk sanat türü",
        mapping: {
            type: PropertyMappingType.String
        }
    }]
}
